export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13187.fe2865a6.jpg";